// Import external
import { AfterContentInit, Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { uniq } from 'lodash';

import { MatMenuTrigger } from '@angular/material/menu';
import { MatSelectChange } from '@angular/material/select';
import { SearchFilter } from './search-v2-filter';
import { SearchbarFacet } from './searchbar-v2-facet';
import { SearchbarTranslations } from './searchbar-v2.component';

@Component({
    selector: 'syn-search-v2-filter-widget',
    templateUrl: 'search-v2-filter-widget.component.html',
    styleUrls: ['search-v2-filter-widget.component.scss'],
})

export class SearchFilterWidgetV2Component implements OnInit, AfterContentInit {

    @Input() public trigger: MatMenuTrigger;
    @Input() public facets: SearchbarFacet[];
    @Input() public translations: SearchbarTranslations;

    @ViewChild('autocompleteContainer', { read: ViewContainerRef, static: true }) public autocompleteContainer: ViewContainerRef;
    @ViewChild('autocompleteTemplate', { read: TemplateRef }) public autocompleteTemplate: TemplateRef<object>;

    @Output() public submitted: EventEmitter<SearchFilter> = new EventEmitter<SearchFilter>();

    public searchFilterForm: FormGroup;
    public searchFilter: SearchFilter;
    public groupedFacets: {
        groups: Array<{ name: string; facets: SearchbarFacet[] }>;
        facets: SearchbarFacet[];
    } = { groups: [], facets: [] };

    public filter: SearchFilter;

    get selectedFacet(): SearchbarFacet {
        return this.facets.find((facet) => facet.property === this.filter.property);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get facetOptions(): any {
        return this.selectedFacet && this.selectedFacet.widget.options;
    }

    public ngOnInit(): void {
        this.groupedFacets = uniq(this.facets.map(({ subgroup }) => subgroup)).filter(Boolean).reduce((acc, key) => {
            acc.groups.push({
                name: key,
                facets: this.facets.filter(({ subgroup }) => subgroup === key),
            });
            return acc;
        }, {
            groups: [] as Array<{ name: string; facets: SearchbarFacet[] }>,
            facets: [] as SearchbarFacet[],
        });
        this.groupedFacets.facets = this.facets.filter(({ subgroup }) => !subgroup);
    }

    public ngAfterContentInit(): void {
        this.cleanForm();
    }

    public async onChangeFacet($event: MatSelectChange): Promise<void> {
        const facet = this.facets.find((f) => f.property === $event.value);
        this.filter = new SearchFilter(facet);
        if (facet.widget.type === 'quick') {
            this.submit();
        }

        // hacky to use syn-multi-picker compnonent
        this.autocompleteContainer.detach();
        if (facet.widget.type === 'autocomplete') {
            this.autocompleteContainer.insert(this.autocompleteTemplate.createEmbeddedView(null));
        }
    }

    public cleanForm(): void {
        this.autocompleteContainer.detach();
        if (this.facets.length === 0) {
            return;
        }
        this.filter = new SearchFilter();
    }

    public close(): void {
        this.cleanForm();
        this.trigger.closeMenu();
    }

    public submit(): void {
        this.submitted.emit(this.filter);
        this.cleanForm();
        this.trigger.closeMenu();
    }

    public stopPropagation($event: MouseEvent): void {
        // hacky : Prevent menu closed when user click on widgets
        return $event.stopPropagation();
    }

}
